import { render, staticRenderFns } from "./dspFooter.vue?vue&type=template&id=51af2ef9&"
import script from "./dspFooter.vue?vue&type=script&lang=js&"
export * from "./dspFooter.vue?vue&type=script&lang=js&"
import style0 from "./dspFooter.vue?vue&type=style&index=0&id=51af2ef9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports